import { render, staticRenderFns } from "./puff-map.vue?vue&type=template&id=7af1234b"
import script from "./puff-map.vue?vue&type=script&lang=js"
export * from "./puff-map.vue?vue&type=script&lang=js"
import style0 from "./puff-map.vue?vue&type=style&index=0&id=7af1234b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports